import React from "react";
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Search } from "../../UI/Search/Search";
import "./TaskVerificationToolbar.css";

export const ORG_TASK_SORT_OPTIONS = [
  { label: "Newest submission", sortBy: "submissionTime", sortOrder: "desc" },
  { label: "Oldest submission", sortBy: "submissionTime", sortOrder: "asc" },
  { label: "Most pending tasks", sortBy: "pendingTasks", sortOrder: "desc" },
  { label: "Employee name (A–Z)", sortBy: "name", sortOrder: "asc" },
];

const toSortKey = ({ sortBy, sortOrder }) => `${sortBy}:${sortOrder}`;

const fromSortKey = (sortKey, options) => {
  const match = options.find((option) => toSortKey(option) === sortKey);
  return match ?? options[0];
};

export const TaskVerificationToolbar = ({
  searchVal,
  setSearchVal,
  sortValue,
  onSortChange,
  sortOptions,
  placeholder = "Search by name or email",
  showSort = true,
}) => {
  const hasSort =
    showSort &&
    Array.isArray(sortOptions) &&
    sortOptions.length > 0 &&
    sortValue &&
    typeof onSortChange === "function";
  const sortKey = hasSort ? toSortKey(sortValue) : "";

  return (
    <div className="task-verification-toolbar">
      <Search
        searchVal={searchVal}
        setSearchVal={setSearchVal}
        placehold={placeholder}
        mini
      />
      {hasSort ? (
        <FormControl size="small" className="task-verification-toolbar__sort">
          <Select
            value={sortKey}
            onChange={(event) =>
              onSortChange(fromSortKey(event.target.value, sortOptions))
            }
            displayEmpty
            sx={{
              minWidth: 200,
              backgroundColor: "#fff",
              fontSize: "14px",
            }}
          >
            {sortOptions.map((option) => (
              <MenuItem key={toSortKey(option)} value={toSortKey(option)}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null}
    </div>
  );
};

TaskVerificationToolbar.propTypes = {
  searchVal: PropTypes.string.isRequired,
  setSearchVal: PropTypes.func.isRequired,
  sortValue: PropTypes.shape({
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
  }),
  onSortChange: PropTypes.func,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      sortBy: PropTypes.string.isRequired,
      sortOrder: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  showSort: PropTypes.bool,
};
